<template>
    <div class="scanner-container">
        <input id="barCodeInput" type="text" autocomplete="off" @change="goToProduct">
    </div>
</template>

<script>
// import ProductController from '@/assets/controllers/ProductController.js'
import CartController from '@/assets/controllers/CartController.js'
import eventModule from '@/assets/libs/eventModule'
import Util from '@/assets/libs/util.js'
import requestModule from '../assets/libs/requestModule'
import LocaleController from '@/assets/controllers/LocaleController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
export default {
    name: 'ProductBarcodeScanner',
    data () {
        return {
            interval: null,
            androidBarCode: '',
            gertecBarcodeInterval: null,
            isTap: Util.isTapMode(),
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false
        }
    },
    mounted () {
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            setTimeout(() => {
                window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
            }, 1000)

            this.gertecBarcodeInterval = setInterval(() => {
                let readedCode = window.GertecBarcodeReader.getReadedCode()
                if (readedCode) {
                    this.androidBarCode = readedCode
                    this.goToProduct()
                }
            }, 1000)
        } else if (Util.isAndroidMode()) {
            document.addEventListener('keypress', this.handleAndroidKeypress)
        } else {
            this.startIntervalToReadBarCode()
        }
    },
    beforeDestroy () {
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            clearInterval(this.gertecBarcodeInterval)
            window.GertecBarcodeReader.stopDecode()
        } else if (Util.isAndroidMode()) {
            document.removeEventListener('keypress', this.handleAndroidKeypress)
        } else {
            clearInterval(this.interval)
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        handleAndroidKeypress: function (event) {
            if (event.key === 'Enter') {
                this.goToProduct()
            } else {
                this.androidBarCode += event.key
            }
        },
        startIntervalToReadBarCode: function () {
            const vm = this
            const barCodeInput = document.getElementById('barCodeInput')
            barCodeInput.focus()
            this.interval = setInterval(() => {
                if (vm.$router.currentRoute.name === 'Home' || (this.isTap && vm.$router.currentRoute.name === 'Checkout')) {
                    barCodeInput.focus()
                } else {
                    clearInterval(this.interval)
                }
            }, 500)
        },
        goToProduct: async function (ev) {
            let insertedBarCode = Util.isAndroidMode() ? this.androidBarCode : ev.srcElement.value
            eventModule.$emit('restartTimeout')
            if (this.isTap) {
                this.$emit('handleBarCode', insertedBarCode)
                insertedBarCode = ''
                this.androidBarCode = ''
                ev.srcElement.value = ''
                return
            }
            // const products = ProductController.getProdItem('unique').filter(p => (!!p.productCode || p.subItemCode) && (p.productBarCode || p.subItemBarCode))
            let weighingConfig = Util.getLocalConfigs('curtaa').weighingConfig || null
            let barcodeStart = weighingConfig && weighingConfig.initialBarProd
            let barcodeEnd = weighingConfig && weighingConfig.finalBarProd

            let isEan13BarCode = insertedBarCode && insertedBarCode.length === 13 && barcodeStart && barcodeEnd

            let foundByEan13 = false
            let barCode = insertedBarCode
            // let foundProd = products.find(p => (p.productBarCode || p.subItemBarCode) === barCode)
            let foundProd = await this.getProduct(barCode)
            if ((!foundProd || !foundProd.productBarCode) && isEan13BarCode) {
                barCode = this.getProdBarcodeFromEan13(insertedBarCode)
                // foundProd = products.find(p => (p.productBarCode || p.subItemBarCode) === barCode)
                foundProd = await this.getProduct(barCode)
                foundByEan13 = foundProd && foundProd.productBarCode
            }

            if (!foundProd || !foundProd.productBarCode) {
                Util.showInfoModal(this.getString('nenhum_produto_encontrado'))
            }

            if (foundProd && foundProd.productBarCode) {
                let diffPrice = DifferentiatedPricesController.getDiffPrice(foundProd.productCode, false, foundProd)
                if (diffPrice) {
                    foundProd.price = diffPrice
                }
                foundProd.discount = 0
                if (foundByEan13) {
                    this.ean13BarcodeProductAdd(insertedBarCode, foundProd)
                } else {
                    this.barcodeProductAdd(foundProd)
                }
            }

            if (Util.isAndroidMode()) {
                this.androidBarCode = ''
            } else {
                ev.srcElement.value = ''
            }
        },
        getProdBarcodeFromEan13: function (insertedBarCode) {
            try {
                let weighingConfig = Util.getLocalConfigs('curtaa').weighingConfig
                let barcodeStart = weighingConfig.initialBarProd
                let barcodeEnd = weighingConfig.finalBarProd
                // O código de barras parametrizado pode ter entre 4 e 6 dígitos
                let barcodeInCorrectRange = barcodeEnd - barcodeStart >= 3 && barcodeEnd - barcodeStart <= 5
                if (barcodeInCorrectRange) return insertedBarCode.substring(barcodeStart - 1, barcodeEnd)
            } catch (error) {
                console.log(error.message)
            }
            return ''
        },
        ean13BarcodeProductAdd: function (insertedBarCode, foundProd) {
            foundProd = Util.deepCopy(foundProd)
            foundProd.quantity = this.getQuantityFromEan13(insertedBarCode, foundProd)
            foundProd.insertedByEan13 = true
            if (foundProd.quantity > 0) this.addFoundProdToCart(foundProd)
        },
        getQuantityFromEan13: function (insertedBarCode, foundProd) {
            let weighingConfig = Util.getLocalConfigs('curtaa').weighingConfig
            let configuredToUseQuantity = weighingConfig.initialQtty != null && weighingConfig.finalQtty != null
            let configuredToUseValue = weighingConfig.initialValue != null && weighingConfig.finalValue != null
            let quantity

            if (configuredToUseQuantity) {
                quantity = insertedBarCode.substring(weighingConfig.initialQtty - 1, weighingConfig.finalQtty)
                quantity = parseFloat(quantity) / 1000
            } else if (configuredToUseValue) {
                let weightedPriceStr = insertedBarCode.substring(weighingConfig.initialValue - 1, weighingConfig.finalValue)
                let weightedPrice = parseFloat(weightedPriceStr) / 100
                quantity = weightedPrice / foundProd.price
                quantity = parseFloat(quantity.toFixed(3))
            }

            return Number.isNaN(quantity) ? 0 : quantity
        },
        barcodeProductAdd: function (foundProd) {
            foundProd = Util.deepCopy(foundProd)
            foundProd.quantity = 1
            foundProd.isertedByBarCode = true
            this.addFoundProdToCart(foundProd)
        },
        addFoundProdToCart: function (foundProd) {
            CartController.addToCart(foundProd)
            eventModule.$emit('barCodeProductAdd')
            eventModule.$emit('openCart', true)
        },
        getProduct: async function (barCode) {
            eventModule.$emit('toggleWaitStatus', true)
            const generalInfo = Util.getGeneralInfo(false)
            let payload = {
                ...generalInfo,
                productBarCode: barCode
            }
            return requestModule.postRequest('menu/getProduct', payload)
                .then(r => (r && r.data) || {})
                .catch(e => {
                    console.log(e)
                    return {}
                }).finally(() => {
                    eventModule.$emit('toggleWaitStatus', false)
                })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");
    .scanner-container{
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 5;
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/ProductBarcodeScanner.vue